import { ResonanceMatch } from './types';

export interface GoeticSpirit {
  id: number;
  name: string;
  rank: string;
  legions: number;
  domain: string;
  keySignatures?: number[];
}

export interface Qlipha {
  id: number;
  name: string;
  hebrew: string;
  archdemon: string;
  domain: string;
  keySignatures: number[];
}

export const GOETIC_SPIRITS: GoeticSpirit[] = [
  { id: 1, name: 'Bael', rank: 'King', legions: 66, domain: 'Invisibility, subterranean wisdom' },
  { id: 2, name: 'Agares', rank: 'Duke', legions: 31, domain: 'Halting runaways, earthquakes, languages' },
  { id: 3, name: 'Vassago', rank: 'Prince', legions: 26, domain: 'Declaring past and future, finding lost things' },
  { id: 4, name: 'Samigina', rank: 'Marquis', legions: 30, domain: 'Necromancy, sciences of the dead' },
  { id: 5, name: 'Marbas', rank: 'President', legions: 36, domain: 'Hidden mechanics, healing, architecture' },
  { id: 6, name: 'Valefor', rank: 'Duke', legions: 10, domain: 'Familiar spirits, cunning thievery' },
  { id: 7, name: 'Amon', rank: 'Marquis', legions: 40, domain: 'Reconciling controversies, feuds' },
  { id: 8, name: 'Barbatos', rank: 'Duke', legions: 30, domain: 'Understanding beast languages, opening treasures' },
  { id: 9, name: 'Paimon', rank: 'King', legions: 200, domain: 'Secret arts, binding, dignity and sciences' },
  { id: 10, name: 'Buer', rank: 'President', legions: 50, domain: 'Natural philosophy, herbalism, moral virtues' },
  { id: 15, name: 'Eligos', rank: 'Duke', legions: 60, domain: 'Military strategy, wars, hidden soldiers' },
  { id: 20, name: 'Purson', rank: 'King', legions: 22, domain: 'Earthly treasures, occult secrets, divination' },
  { id: 25, name: 'Glasya-Labolas', rank: 'President / Earl', legions: 36, domain: 'Sudden bloodshed, all arts and sciences' },
  { id: 32, name: 'Asmoday', rank: 'King', legions: 72, domain: 'Invincible wrath, geometry, craftsmanship' },
  { id: 40, name: 'Raum', rank: 'Earl', legions: 30, domain: 'Destroying cities, reconciling animosities' },
  { id: 45, name: 'Vine', rank: 'King / Count', legions: 36, domain: 'Uncovering secrets, building towers, storms' },
  { id: 51, name: 'Balam', rank: 'King', legions: 40, domain: 'Past and future sight, sharp wit, invisibility' },
  { id: 61, name: 'Zagan', rank: 'King / President', legions: 33, domain: 'Transmutation of metals and fluids, wit' },
  { id: 64, name: 'Flauros', rank: 'Duke', legions: 36, domain: 'Destroying enemies with fire, true answers' },
  { id: 68, name: 'BELIAL', rank: 'King', legions: 80, domain: 'Master of the 80 Legions, Lord of the Soil, Jurist of Hell, radical sovereignty', keySignatures: [68, 80, 73, 57, 142, 666, 218] },
  { id: 70, name: 'Seere', rank: 'Prince', legions: 26, domain: 'Instantaneous transit, earthly abundance' },
  { id: 72, name: 'Andromalius', rank: 'Earl', legions: 36, domain: 'Apprehending thieves, punishing deceit, hidden goods' }
];

export const QLIPHOTH_SPHERES: Qlipha[] = [
  { id: 1, name: 'Thamiel', hebrew: 'תאומיאל', archdemon: 'Satan & Moloch', domain: 'The Twins of God / Primal Bifurcation', keySignatures: [1, 11, 488, 666] },
  { id: 2, name: 'Chaigidel', hebrew: 'עוגיאל', archdemon: 'Beelzebub', domain: 'The Hinderers / Chaos and Void Breath', keySignatures: [2, 55, 83, 777] },
  { id: 3, name: 'Sathariel', hebrew: 'סתריאל', archdemon: 'Lucifuge Rofocale', domain: 'The Concealers / Black Womb of Binah', keySignatures: [3, 701, 333, 999] },
  { id: 4, name: 'Gamchicoth', hebrew: 'גמחיכות', archdemon: 'Astaroth', domain: 'The Devourers / Ruthless Sovereignty', keySignatures: [4, 487, 444, 218] },
  { id: 5, name: 'Golachab', hebrew: 'גולחב', archdemon: 'Asmodeus', domain: 'The Burning Ones / Severing Fire', keySignatures: [5, 49, 358, 65] },
  { id: 6, name: 'Thagirion', hebrew: 'תגרירון', archdemon: 'Belphegor', domain: 'The Disputers / Black Sun & Solar Ego', keySignatures: [6, 869, 666, 400] },
  { id: 7, name: 'Harab Serapel', hebrew: 'ערב שרף', archdemon: 'Baal', domain: 'Ravens of Dispersion / Predatory Will', keySignatures: [7, 852, 272, 580] },
  { id: 8, name: 'Samael', hebrew: 'סמאל', archdemon: 'Adrammelech', domain: 'Poison of God / Skepticism & Discernment', keySignatures: [8, 131, 888, 64] },
  { id: 9, name: 'Gamaliel', hebrew: 'גמליאל', archdemon: 'Lilith', domain: 'The Obscene Ass / Lunar Chthonic Dreams', keySignatures: [9, 114, 480, 210] },
  { id: 10, name: 'Nahemoth', hebrew: 'נעמות', archdemon: 'Naamah & Belial', domain: 'The Pleasant Ones / Earth of Hell & Living Bedrock', keySignatures: [10, 566, 68, 80, 73, 142] },
  { id: 11, name: "Da'ath / Choronzon", hebrew: 'דעת', archdemon: 'Choronzon & Belial', domain: 'The Threshold Void / Dissolution of Illusion', keySignatures: [11, 474, 333, 77] }
];

export const BELIALIAN_KEY_NUMBERS = [68, 80, 73, 57, 142, 666, 218];

export function findResonances(sum: number): ResonanceMatch[] {
  if (sum <= 0) return [];
  const matches: ResonanceMatch[] = [];

  // 1. Direct Harmonic Lock Check
  if (BELIALIAN_KEY_NUMBERS.includes(sum)) {
    matches.push({
      goeticNumber: 68,
      goeticName: 'KING BELIAL',
      rank: 'King of the Earth',
      qliphothicSphere: 'Nahemoth (Physical Underworld)',
      harmonicLock: true,
      resonanceScore: 1.0,
      matchType: 'HARMONIC_LOCK',
      description: `DIRECT HARMONIC LOCK: Numerical value ${sum} aligns perfectly with the sovereign signature of King Belial.`
    });
  }

  // 2. Goetic Modulo Cycle (1 to 72)
  const goeticId = ((sum - 1) % 72) + 1;
  const goeticSpirit = GOETIC_SPIRITS.find(s => s.id === goeticId) || {
    id: goeticId,
    name: `Goetic Spirit #${goeticId}`,
    rank: 'Legion Commander',
    legions: 30,
    domain: 'Chthonic office of the 72 spirits'
  };

  matches.push({
    goeticNumber: goeticSpirit.id,
    goeticName: goeticSpirit.name,
    rank: goeticSpirit.rank,
    qliphothicSphere: 'Nahemoth',
    harmonicLock: sum === goeticSpirit.id || goeticSpirit.id === 68,
    resonanceScore: sum === goeticSpirit.id ? 0.95 : 0.75,
    matchType: sum === goeticSpirit.id ? 'EXACT' : 'MODULO_CYCLE',
    description: `Resonates with Goetic #${goeticSpirit.id} (${goeticSpirit.name}, ${goeticSpirit.rank}) via cycle mod 72: ${goeticSpirit.domain}.`
  });

  // 3. Qliphothic Sphere Match (1 to 10 or 11)
  const qliphaId = ((sum - 1) % 10) + 1;
  const qlipha = QLIPHOTH_SPHERES.find(q => q.id === qliphaId) || QLIPHOTH_SPHERES[9];

  matches.push({
    goeticNumber: goeticId,
    goeticName: qlipha.archdemon,
    rank: 'Archdemon',
    qliphothicSphere: `${qlipha.name} (${qlipha.hebrew})`,
    harmonicLock: qlipha.keySignatures.includes(sum),
    resonanceScore: qlipha.keySignatures.includes(sum) ? 0.90 : 0.70,
    matchType: qlipha.keySignatures.includes(sum) ? 'EXACT' : 'MODULO_CYCLE',
    description: `Aligned to Qliphothic Sphere ${qlipha.name}: ${qlipha.domain}.`
  });

  // 4. Belial's 80 Legions Modulo Cycle (1 to 80)
  const legionId = ((sum - 1) % 80) + 1;
  matches.push({
    goeticNumber: 68,
    goeticName: `Belialian Cohort Legion #${legionId}`,
    rank: 'Subterranean Legion',
    qliphothicSphere: 'Nahemoth',
    harmonicLock: legionId === 80 || legionId === 68,
    resonanceScore: 0.80,
    matchType: 'MODULO_CYCLE',
    description: `Mobilizes Belial's 80-Legion Brass Vessel cohort at index #${legionId}.`
  });

  return matches;
}
